import {
  useMultitabState,
  useSetMultitabReady,
  useTabActiveBackend,
  useTabOperations,
} from './state';
import styled from '@emotion/styled';
import Page from './Page';
import PageTab from './PageTab';
import ErrorBoundary, { ErrorResult } from 'components/ErrorBoundary';
import { Button, Tooltip } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { useMount } from 'ahooks';
import { zIndex } from 'services/config/styles';

function Multitab() {
  const { activeKey, list } = useMultitabState();
  const setMultitabReady = useSetMultitabReady();
  const { updateActiveKey, closeTab, closeUnactiveTabs, t } = useTabOperations();
  const tabActiveBackend = useTabActiveBackend();

  useMount(() => {
    setMultitabReady(true);
  });

  return (
    <Container style={activeKey ? undefined : { display: 'none' }}>
      <div>
        <ul>
          {list.map((tab) => {
            return (
              <PageTab
                key={tab.path}
                tab={tab}
                active={tab.path === activeKey}
                onActive={updateActiveKey}
                onClose={closeTab}
              />
            );
          })}
        </ul>
        {list.length > 1 && (
          <span>
            <Tooltip arrowPointAtCenter placement="left" title={t('关闭其他页签')}>
              <Button type="text" icon={<CloseCircleFilled />} onClick={closeUnactiveTabs} />
            </Tooltip>
          </span>
        )}
      </div>
      {list.map((tab) => {
        const active = tab.path === activeKey;
        return tabActiveBackend(tab.path) ? (
          <ErrorBoundary
            key={tab.path}
            fallback={(_, reset) => (
              <section style={active ? undefined : { display: 'none' }}>
                <ErrorResult onClick={reset} />
              </section>
            )}
          >
            <Page tab={tab} active={active} />
          </ErrorBoundary>
        ) : null;
      })}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--fett-bg-app);
  z-index: ${zIndex.base};
  > div {
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    height: 40px;
    background: var(--fett-bg-panel);
    border-bottom: solid 1px var(--fett-border-default);
    overflow: hidden;
    > ul {
      flex: 1 0 0;
      display: flex;
      align-items: flex-end;
      flex-wrap: nowrap;
      margin: 0;
      padding: 0;
      list-style: none;
      overflow: hidden;
      > li {
        flex: 1 1 0;
        width: 0;
        max-width: 160px;
      }
    }
    > span {
      flex: 0 0 auto;
      position: relative;
      padding: 0 12px 0 8px;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 8px;
        left: 0;
        width: 2px;
        height: 16px;
        background: var(--fett-border-default);
      }
      > button {
        color: var(--fett-text-tertiary);
      }
    }
  }
  > section {
    flex: 1 0 0;
    overflow: hidden;
    > * {
      height: 100%;
    }
  }
`;

export default Multitab;
